import {Checkbox, classNames, layout, PushButton, TextInput} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useState} from "react";
import {stylesheet} from "typestyle";
import {Tool} from "./Tool";
import {MockToolProps} from "./types";

export function BarcodeTool({mockController, align}: MockToolProps) {
	const [code, setCode] = useState("");

	const handleShowBarcode = useCallback(() => {
		mockController.barcodeReader.scanBarcode(code);
	}, [code]);

	return (
		<Tool label="Barcode" align={align}>
			<div className={classNames(layout.paddingLarge)}>
				<Checkbox
					onChange={checked => mockController.setBarcodeEnabled(checked)}
					defaultChecked={mockController.isBarcodeEnabled()}
				>
					Connected
				</Checkbox>
				<div className={styles.inputContainer}>
					<TextInput value={code} onChange={setCode} outline placeholder="Barcode" className={styles.input} />
				</div>
				<PushButton onClick={handleShowBarcode} primary className={styles.button}>
					Scan Barcode
				</PushButton>
			</div>
		</Tool>
	);
}

const styles = stylesheet({
	input: {
		width: "16em",
	},
	inputContainer: {
		paddingBottom: "1em",
	},
	button: {
		display: "block",
		width: "100%",
	},
});
